import React, { useState } from 'react';
import { Typography, Configurations, Button } from '@hpstellar/core';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import withPageComponents from '../../../page/components/with-page-components';
import ShareConfig from '../share-config';
import HelpSection from '../help-section';
import ConsumerFinanceWidget from '../../../product/components/consumer-finance-widget';
import useSpecsSelected from './useSelectedSpecs';
import SavingsProgressBar from '../savings-progress-bar';
import './configure-specs.less';

const EMPTY_OBJ = {};
export default withPageComponents(
    ({ baseConfig = {}, ctoPrice, ctoProductInitial, shipDate, device, ctoSettings }) => {
        const [modalOpen, setModalOpen] = useState(-1);
        const { typography } = useTemplateTheme(['typography']);
        const { primaryButtonLinkClassName } = typography || {};

        const { initialPrice, ULList } = baseConfig;
        const isMobile = device === 'mobile';
        const { disableFPS } = ctoSettings || {};
        const displayFPSCalc = !disableFPS && Object.keys(ULList || {}).length > 0 && !isMobile;

        //initial price is provided for crawlers, use it when available until async price data becomes available
        const price = typeof ctoPrice === 'undefined' && initialPrice ? initialPrice : ctoPrice;
        const { days } = shipDate || EMPTY_OBJ;
        const specs = useSpecsSelected(baseConfig);
        const closeModal = () => {
            setModalOpen(0);
        };

        if (device === 'mobile') {
            return null;
        }

        return (
            <div className="configure-specs-container ">
                <div className={`configure-specs-sticky ${displayFPSCalc ? ' fps-calc' : ''}`}>
                    <SavingsProgressBar />
                    <div className="configure-specs">
                        {days < 31 ? <ConsumerFinanceWidget price={price} product={ctoProductInitial} /> : null}
                        <div className="configure-title-row">
                            <Typography tag="h2" variant="bodyL">
                                {'YOUR CONFIGURATION'}
                            </Typography>
                            <Button
                                size={'small'}
                                variation="tertiary"
                                action="go"
                                onClick={() => setModalOpen(1)}
                                tabindex={0}
                                className={`share-config ${
                                    primaryButtonLinkClassName ? ` ${primaryButtonLinkClassName}` : ''
                                }`}
                            >
                                SHARE BY EMAIL
                            </Button>
                        </div>
                        <Configurations dividerPosition="top" className="specs-list" content={specs} />
                    </div>
                    {modalOpen >= 0 && <ShareConfig isOpen={modalOpen} onModalClose={closeModal} />}
                    <HelpSection chatFrom="CTOPage" chatReferer="CTO" chatRule="CTO Chat" />
                </div>
            </div>
        );
    },
    { components: ['baseConfig', 'shipDate', 'ctoProductInitial', 'ctoPrice', 'ctoSettings'], device: true },
);
